import {useMemo} from "react";

import {CITATION_FULL_DAY_RANGE} from "@/src/modules/properties/lib/citation-range-hours";
import type {PropertyRuleTimeRange} from "@/src/modules/properties/types";
import {usePropertyTypes} from "@/src/modules/properties/hooks/use-property-types";
import {useStoredMeProperties} from "@/src/modules/core/store/me";
import {useStoredUserProperty} from "@/src/modules/core/store/user-property";

import {
  getSafelistingRangeHoursFromProperty,
  mergePropertyRulesFromMe,
} from "../lib/get-safelisting-range-hours-from-property";

/** Same range-hours resolution as the create/edit sheet (`form.tsx`). */
export function useSafelistingRangeHours(): PropertyRuleTimeRange | null {
  const userProperty = useStoredUserProperty();
  const meProperties = useStoredMeProperties();
  const {propertyTypes, isPending: propertyTypesPending} = usePropertyTypes();

  return useMemo(() => {
    const propertyForRules = mergePropertyRulesFromMe(userProperty, meProperties) ?? userProperty;
    if (!propertyForRules) return null;

    const resolved = getSafelistingRangeHoursFromProperty(propertyForRules, propertyTypes);
    if (resolved) return resolved;
    if (propertyTypesPending) return null;
    return {...CITATION_FULL_DAY_RANGE};
  }, [userProperty, meProperties, propertyTypes, propertyTypesPending]);
}

export default useSafelistingRangeHours;
